import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { handleFileUpload, handleCaptureFileUpload } from "./redux/action";
import {
  makeid,
  resizeFile,
  showPrevBtnByUrl,
  showNextBtnByUrl,
  getPrevAndNextRoute,
} from "utils";
import { setLoading } from "../../../../redux";
import { validateIncomeProof } from "../IncomeProof/redux/action";
import InputTitle from "designs/v1/components/InputTitle";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import Webcam from "react-webcam";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-toastify";
import "./style.css";

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const FILE_TYPES = ["JPG", "JPEG", "PNG", "PDF"];

const videoConstraints = {
  width: 220,
  height: 200,
  facingMode: FACING_MODE_USER,
};

const WebcamCapture = ({ handleImg, handleShow, disabled, show }) => {
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
  const [image, setImage] = useState("");
  const webcamRef = React.useRef(null);

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    handleImg(imageSrc);
  });

  const handleChangeMode = React.useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER
    );
  }, []);

  const handleClose = (bool) => {
    setImage("");
    handleShow(bool);
  };

  return (
    <>
      {show ? (
        <div className="webcam-container">
          <div className="webcam-img">
            {image == "" ? (
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={"100%"}
                videoConstraints={{
                  ...videoConstraints,
                  facingMode,
                }}
              />
            ) : (
              <img src={image} />
            )}
          </div>
          <div>
            {image != "" ? (
              <>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setImage("");
                  }}
                  className="btn btn-success mx-2"
                >
                  Retake Image
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    capture();
                  }}
                  className="btn btn-success mx-2"
                >
                  Capture
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
                {isMobile && (
                  <button
                    type="button"
                    onClick={handleChangeMode}
                    className="btn btn-secondary mx-2"
                  >
                    Switch camera
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <button
          className="btn btn-warning btn-sm"
          disabled={disabled}
          onClick={() => handleShow(true)}
        >
          Open Camera
        </button>
      )}
    </>
  );
};

const Signature = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [signProof, setSignProof] = useState("");
  const { kycStatus, kycPageName } = useSelector((state) => state.navigation);
  const [signatureVerificationSuccess, setSignatureVerificationSuccess] =
    useState(false);
  const [isShow, setIsShow] = useState(false);

  const handleShow = (bool) => {
    setIsShow(bool);
  };

  const handleCaptureSign = (img) => {
    uploadSignatureCaptureImg(img);
  };

  const uploadSignatureImage = async (file) => {
    if (!file) return;
    const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
    if (!allowed_types.includes(file.type)) {
      toast.error("Only Images are allowed ( JPG | PNG | PDF )", "Error");
      return;
    }
    setSignProof(file);
    dispatch(setLoading(true));
    if (file.type === "application/pdf") {
      const fileSize = file.size / 1024 ** 2;
      if (fileSize >= 3) {
        toast.error("Please upload a file smaller than 3MB");
        return;
      }
      let isEncrypted = false;
      try {
        const formData = new FormData();
        formData.append("file", file, makeid(6) + ".pdf");
        const resp = await validateIncomeProof(formData);
        isEncrypted = resp.data?.message || false;
        dispatch(setLoading(false));
      } catch (error) {}
      if (isEncrypted) {
        toast.error("Please upload a file without password protected.");
        dispatch(setLoading(false));
        return;
      }
      const formData = new FormData();
      formData.append("sign_img", file, makeid(6) + ".pdf");
      formData.append("file_type", "pdf");
      dispatch(handleFileUpload(formData));
      return;
    }
    const resizedFile = await resizeFile(file);
    const formData = new FormData();
    formData.append("sign_img", resizedFile, makeid(6) + ".JPEG");
    formData.append("file_type", "Image");
    dispatch(handleFileUpload(formData));
  };

  const uploadSignatureCaptureImg = (file) => {
    // dispatch(setLoading(true));
    let formData = new FormData();
    formData.append("sign_img", file?.replace("data:image/jpeg;base64,", ""));
    formData.append("file_type", "Base64");
    dispatch(handleCaptureFileUpload(formData));
  };

  return (
    <React.Fragment>
      <Title title="Signature" />
      <div className="col-md-9">
        <div className="form-group">
          <div className="row">
            <div className="col-md-12">
              <InputTitle
                title={"Upload your signature (jpg, png, pdf)"}
                className={"my-1"}
              />
            </div>
          </div>

          {signatureVerificationSuccess ? (
            "Signature Verified"
          ) : (
            <>
              {/* <input
              type="file"
              accept="image/*,application/pdf"
              className="form-control"
              onChange={uploadSignatureImage}
            /> */}
              <div className="file-uploader-container">
                <FileUploader
                  handleChange={(file) => uploadSignatureImage(file)}
                  name="file"
                  types={FILE_TYPES}
                />
              </div>
              {signProof?.name && (
                <p>
                  <small>File name: {signProof.name}</small>
                </p>
              )}
              <div>
                <label className="my-1 text-muted text-sm">
                  <small>Maximum file size: 4 MB</small>
                </label>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="col-md-6 mt-2">
        <div style={{ position: "relative" }}>
          <WebcamCapture
            handleImg={handleCaptureSign}
            handleShow={handleShow}
            show={isShow}
          />
        </div>
      </div>
      <div className="col-md-12 d-flex mt-4">
        {showPrevBtnByUrl(
          history.location.pathname,
          kycStatus,
          kycPageName
        ) && (
          <Button
            title="Previous"
            type="button"
            className="mx-1"
            handleClick={() => {
              const route = getPrevAndNextRoute(
                history.location.pathname.slice(1),
                kycPageName
              );
              history.push(route.prev);
            }}
          />
        )}
        {showNextBtnByUrl(
          history.location.pathname,
          kycStatus,
          kycPageName
        ) && (
          <Button
            title="Next"
            type="button"
            className="mx-1"
            handleClick={() => {
              const route = getPrevAndNextRoute(
                history.location.pathname.slice(1),
                kycPageName
              );
              history.push(route.next);
            }}
          />
        )}
      </div>
      {/* <div className="col-md-12 mt-3">
        <Button
          type="button"
          disabled={loading}
          title="Submit"
          handleClick={() => console.log("")}
        />
      </div> */}
    </React.Fragment>
  );
};

export default Signature;
